import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  setProfileModalPage,
  setProfileModalDetailPage,
} from '../../../modules/profile/actions/creators'

import MessagesPage from '../components/MessagesPage/MessagesPage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { profileModalPage, profileDetailPage } = profile

  return {
    accessToken,
    profileModalPage,
    profileDetailPage,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProfileModalPage,
      setProfileModalDetailPage,
    },
    dispatch,
  )

const ConnectedMessagesPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MessagesPage)

export default ConnectedMessagesPage
